<template>
  <BaseButton
    variant="primary"
    size="sm"
    :color="modeColor">
    {{ modeTitle }}
  </BaseButton>
</template>

<script>
export default {
    props: {
        mode: String
    },
    computed: {
        modeColor() {
            return {
                'inside': 'v1-grey-10',
                'preorder': 'yellow-4',
                'delivery': 'blue-4',
                'reserve': 'green-5',
                'rooms': 'v1-grey-10',
                'cafe': 'v1-grey-10'
            }[this.mode] || 'v1-grey-10';
        },
        modeTitle() {
            return {
                'inside': 'INSIDE',
                'preorder': 'TAKEAWAY',
                'delivery': 'DELIVERY',
                'reserve': 'RESERVE',
                'rooms': 'ROOMS',
                'cafe': 'CAFE',
                'cafe_review': 'CAFE'
            }[this.mode] || this.mode;
        }
    }
}
</script>

<style>

</style>